var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"engineering-reports"},[_c('h2',[_vm._v(_vm._s(_vm.quoteNumber))]),(_vm.loading)?[_c('p',[_vm._v("Loading...")])]:(_vm.hasReports)?[_c('ul',{staticClass:"engineering-reports-list"},_vm._l((_vm.reports),function(report){return _c('li',{key:report.slug},[_c('router-link',{attrs:{"to":{ 
            name: 'Engineering Report', 
            params: {
              slug: report.slug, 
              quoteNumber: _vm.quoteNumber
            }
          }}},[_vm._v(_vm._s(report.title))])],1)}),0),_c('file-download-link',{attrs:{"src":_vm.spreadsheetDownloadURL}})]:[_c('p',[_vm._v("No reports available for this survey.")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }